import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import Button from "src/components/button/Button";

import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/store/store";
import { setPostCategoryId, setRankCategoryId, setCompanyCorpId, setCompanySectorId } from "src/store/category";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/effect-coverflow"

interface SwipeButtonProp {
  type: string;
}

const SwipeButton: React.FC<SwipeButtonProp> = ({ type }) => {
  const dispatch = useDispatch();

  const postCategoryId = useSelector((state: RootState) => state.category.postCategoryId);
  const rankCategoryId = useSelector((state: RootState) => state.category.rankCategoryId);
  const companyCorpId = useSelector((state: RootState) => state.category.companyCorpId);
  const companySectorId = useSelector((state: RootState) => state.category.companySectorId);
  const categories = useSelector((state: RootState) => state.main.categories);
  const corps = useSelector((state: RootState) => state.main.corps);
  const sectors = useSelector((state: RootState) => state.main.sectors);
  const companyTab = useSelector((state: RootState) => state.tab.companyTab);

  const categoryType = useMemo(() => {
    if (type === "/post") return postCategoryId;
    if (type === "/ranking") return rankCategoryId;
    if (type === "/securitiescompany") {
      return companyTab === "증권사" ? companyCorpId : companySectorId;
    }
    return "";
  }, [type, companyTab, postCategoryId, rankCategoryId, companyCorpId, companySectorId]);

  const categoryList = useMemo(() => {
    if (type === "/post") return [
      { id: 0, name: "열람율", cnt: 0 },
      { id: 1, name: "조회수", cnt: 0 }
    ];
    if (type === "/ranking") return categories;
    if (type === "/securitiescompany") {
      return companyTab === "증권사" ? corps : sectors;
    }
    return [];
  }, [type, companyTab, categories, corps, sectors]);

  const handleCategoryChange = (newCategory: number) => {
    if (type === "/post") {
      dispatch(setPostCategoryId(newCategory));
    } else if (type === "/ranking") {
      dispatch(setRankCategoryId(newCategory));
    } else if (type === "/securitiescompany") {
      if (companyTab === "증권사") {
        dispatch(setCompanyCorpId(newCategory));
      } else if (companyTab === "업종") {
        dispatch(setCompanySectorId(newCategory));
      }
    } 
  };
  

  return (
    <Swiper
      modules={[FreeMode]}
      freeMode={true}
      slidesPerView="auto"
      resistance={true}
      watchOverflow={false}
      spaceBetween={10}
      className="swiper-container btn-wrap mb-3"
      style={{ cursor: "grab" }}
    >
      {categoryList.map((item, index) => (
        <SwiperSlide key={item.id}>
          <Button 
            name={item.name} 
            isActive={item.id === categoryType} 
            onClick={() => handleCategoryChange(item.id)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwipeButton;
